import { WebhookDeliveryStatus, WebhookProvider } from '@today/types'
import { z } from 'zod'

// ─── Public-facing schemas ────────────────────────────────────────────────────
//
// `tenantId` is NOT part of any input: on the administrative routes it comes
// from the DB-resolved principal, and on the delivery route it comes from the
// stored endpoint record (ADR-0034, REQ-005). A caller can never name it.

/**
 * Registering a delivery endpoint. `provider` must name a listed provider —
 * anything else is refused 422, which is what "unknown providers fail closed"
 * means at the registration boundary (REQ-003).
 */
export const webhookEndpointCreateSchema = z.object({
	provider: z.enum(WebhookProvider),
})

/**
 * Ledger list filters (REQ-011). Every field is optional; an absent filter does
 * not narrow. Instants are ISO-8601 and parsed strictly, so an unparseable value
 * is a 422 rather than a silently ignored filter.
 */
export const webhookListQuerySchema = z.object({
	provider: z.enum(WebhookProvider).optional(),
	status: z.enum(WebhookDeliveryStatus).optional(),
	receivedFrom: z.iso.datetime({ offset: true }).optional(),
	receivedTo: z.iso.datetime({ offset: true }).optional(),
	pageSize: z.coerce.number().int().min(1).max(100).default(25),
	cursor: z.string().min(1).optional(),
})

export type WebhookEndpointCreateInput = z.infer<typeof webhookEndpointCreateSchema>
export type WebhookListQueryInput = z.infer<typeof webhookListQuerySchema>
